module.exports = __webpack_public_path__ + "img/woman.972ca0f2.png";